export const WIDGET_MESSAGE = "activation.homepage.widget.competitors_traffic_share.message";
export const WIDGET_MESSAGE_SINGLE = "activation.homepage.widget.competitors_traffic_share.message.single";
export const EMPTY_MESSAGE = "activation.homepage.widget.competitors_traffic_share.empty";
export const EMPTY_TOPIC_NAME = "activation.homepage.widget.competitors_traffic_share.empty.topic.name";
